import React, { useState, useEffect } from 'react';
import { allEmailTemplet, deleteEmailTemplet } from "../../../ReduxStore/Slice/Templets/EmailTemplet";
import { useDispatch } from 'react-redux';
import Datatable from '../../../ExtraComponents/ReusableTable2';
import { useNavigate } from 'react-router-dom';
import { PenLine, Trash2 } from 'lucide-react';
import sweatalert from "sweetalert2";
import { Eye } from 'lucide-react';
import ReusableModal from '../../../ExtraComponents/ReusableModal';
import ReactPaginate from "react-paginate";


const AllEmailTemplets = () => {
  const dispatch = useDispatch();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [getAllEmailTempletData, setAllEmailTempletData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);
  const [selectedRow, setSelectedRow] = useState({});

  const [InputValue, setInputValue] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);


  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  }

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])



  useEffect(() => {
    getAllEmailTemplet();;
  }, [currentPage, pageSize, InputValue]);



  const getAllEmailTemplet = async () => {
    const req = { agent_id: agent_id, page: currentPage, limit: pageSize, search: InputValue };
    await dispatch(allEmailTemplet(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setAllEmailTempletData(response.data);
          setTotalRecords(response?.pagination?.total)
        } else {
          setAllEmailTempletData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };





  const deleteEmailTempletRow = async (row) => {
    sweatalert.fire({
      title: "Are you sure?",
      text: "You want to delete this Email Template! ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const req = { id: row.id, agent_id: agent_id };
        await dispatch(deleteEmailTemplet(req)).unwrap()
          .then((response) => {
            if (response.status) {
              sweatalert.fire({
                title: "Success",
                text: "Email Templet Deleted Successfully",
                icon: "success",
                 timer: 3000,
                timerProgressBar: true
              }
              );
              getAllEmailTemplet()
            }
          })
          .catch((error) => {
            console.error("Error deleting package:", error);
          });
      } else if (result.dismiss === sweatalert.DismissReason.cancel) {
        return
      }
    });

  }


  const handleEdit = (row) => {
    navigate(`/admin/template/edit-email-template`, { state: row });
  }

  const columns = [
    {
      name: "Template Name",
      selector: (row) => row?.name,
      sortable: true,
    },

    {
      name: "Subject",
      selector: (row) => row?.subject,
      sortable: true,
    },
    {
      name: 'View Template',
      selector: (row) => <Eye onClick={() => { setShowModal(true); setSelectedRow(row) }} />,
      sortable: true

    },

    {
      name: "Action",
      selector: (row) => <>
        <PenLine onClick={() => handleEdit(row)} />
        <Trash2
          onClick={() => deleteEmailTempletRow(row)}
        />
      </>,
      sortable: true,
    },
  ];

  return (
    <div>

      <section className="section dashboard">

        <div className="row">
          <div className='row'>
            <h5 className='col-lg-10'>
              <span className="ay-name" id="Day_Name">
                Email Templates
              </span>
            </h5>
            <div className='col-lg-2'>
              <button className="btn btn-pink rounded ms-2 float-lg-end" onClick={() => navigate('/admin/template/create-email-template')}>
                Create New
              </button>
            </div>

          </div>

          <div>
            <div className="row">
              <data className='col-lg-3 datatable-search'>
                <input type="text"
                  className='search p-2 icon'
                  placeholder='Search here'
                  value={InputValue}
                  onChange={(e) => setInputValue(e.target.value)}

                />
              </data>

            </div>
            < div className=''>
              <Datatable
                columns={columns}
                data={getAllEmailTempletData}
                filter={false}
              />
              {getAllEmailTempletData.length > 0 ? <div>
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize) || 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={handlePageChange}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />

                <div className="mt-0">

                  <select className="perpage-select" value={pageSize} onChange={handlePageSizeChange}>
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={500}>500</option>
                    <option value={0}>{"ALL"}</option>


                  </select>

                </div>
              </div> : ""}
            </div>
          </div>


        </div>
      </section>
      <ReusableModal
        show={showModal}
        onClose={handleCloseModal}
        modalsize={"xl"}
        title={"Template Preview"}
        body={
          <>
            <div
              className="modal-body preview-body"
              dangerouslySetInnerHTML={{ __html: selectedRow.body || "" }}
              readOnly
            />
          </>
        }
        footer={
          <>
            <button className='btn btn-outline-secondary' onClick={handleCloseModal}>Cancel</button>

          </>
        }
      />

    </div>
  );
};

export default AllEmailTemplets;
